import React, {useState, useContext} from 'react';
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {CKEditor} from "@ckeditor/ckeditor5-react";
import BalloonBlock from "@ckeditor/ckeditor5-build-balloon-block";
import '../styles/patientSocialHistory.css';
import {NetworkContext} from "../utils/NetworkContext";

function PatientSocialHistory({width, setPatient, patient, setDraft, locale}) {
    const {wsCall} = useContext(NetworkContext);
    const [sh, setSh] = useState(patient.sh);

    const EditorChange = data => {
        setSh(data);

        if (data && data.length % 10 === 0) {
            const item = {...patient};
            item.sh = data;
            setPatient(item);

            const message = {
                type: 'wss',
                path: 'patient',
                action: 'update',
                data: {
                    patient: patient.id,
                    sh: data
                }
            };
            wsCall(message);
        }
    }

    const EditorBlur = () => {
        setDraft(false);

        const item = {...patient};
        item.sh = sh;
        setPatient(item);

        const message = {
            type: 'wss',
            path: 'patient',
            action: 'update',
            data: {
                patient: patient.id,
                sh: sh
            }
        };
        wsCall(message);
    }

    return (
        <div className="cs-patient-social-history-page">
            {width > 768 &&
                <div className="mbsc-row cs-patient-social-history-title" />
            }
            <CKEditor
                id="editor-focus"
                config={{
                    toolbar: ['bold', 'italic', 'link'],
                    blockToolbar: ['heading', '|', 'bold', 'italic', 'link', 'blockQuote', '|', 'bulletedList', 'numberedList', '|', 'undo', 'redo'],
                    placeholder: locale.patientSocialHistory.a
                }}
                editor={BalloonBlock}
                data={sh}
                onChange={(event, editor) => EditorChange(editor.getData())}
                onBlur={() => sh !== patient.sh ? EditorBlur() : null}
            />
            <div className="mbsc-row cs-patient-social-history-footer" />
        </div>
    );
}

export default PatientSocialHistory;
